import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import Env from '@/config/env'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
let userAgent = navigator.userAgent.toLowerCase()
router.beforeEach((to, from, next) => {
  if (
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent
    ) &&
    to.fullPath !== '/default'
  ) {
    location.replace(Env.mobileUrlFormal + '/default')
  } else {
    next()
  }
})

export default router
